import React, { useEffect, useState, useMemo } from 'react';
import { BreadCrumbs, LeftBar, LevelsStatus, Header } from 'components';
import { LevelActivating, ActiveLvl, NonActiveLvlList } from 'features/program';
import { BaseLayout } from 'layouts';
import { PROGRAM_MAX_LEVELS, PROGRAM_NAMES } from '../../../helpers/constants';
import { useWeb3React } from '@web3-react/core';
import Lottie from 'lottie-react';
import loadingQornexAnimation from '../../../animations/loadingQornex.json';
import { useSelector } from 'react-redux';
import { getMatrixB } from '../../../store/matrixBSlice/selectors';
import { LoadingAnimation } from '../../../components';
import { useCheckMatrixStatus } from '../../../helpers/hooks/useCheckMatrixStatus';

export const ProgramFrgx = () => {
  useWeb3React();
  const matrixInfo = useSelector(getMatrixB);

  const { matrixStatus, checkMatrixStatus } = useCheckMatrixStatus();

  const allActiveLvls = useMemo(() => {
    return (
      !!matrixInfo?.levels &&
      matrixInfo?.levels.filter((item) => {
        if (Number(item?.expiredAt) !== 0) {
          return item;
        }
      })
    );
  }, [matrixInfo]);

  useEffect(() => {
    if (matrixInfo.levels) {
      checkMatrixStatus(matrixInfo);
    }
  }, [matrixInfo]);

  const nextLvlToActivate =
    allActiveLvls.length < PROGRAM_MAX_LEVELS?.[PROGRAM_NAMES.MATRIX_B] ? allActiveLvls.length + 1 : null;

  const renderContent = useMemo(() => {
    if (matrixInfo?.loading) {
      return <LoadingAnimation />;
    } else {
      return (
        <>
          <div className="flex flex-col items-start rounded-large sm:rounded-3xl instrument-main-bg border-[1px] border-white-100">
            {!!allActiveLvls &&
              allActiveLvls?.map((item, itemIndex) => {
                const matrixLevelStatus = matrixStatus.find((level) => item?.levelNumber === level.levelNumber);
                return <ActiveLvl key={itemIndex} {...item} levelStatus={matrixLevelStatus} matrixs={item.matrixs} />;
              })}
            {nextLvlToActivate && <LevelActivating nextLvl={nextLvlToActivate} />}
          </div>
          {nextLvlToActivate && <NonActiveLvlList activeLvls={allActiveLvls} nextLvl={nextLvlToActivate} />}
        </>
      );
    }
  }, [allActiveLvls, matrixInfo, matrixStatus]);

  return (
    <BaseLayout>
      <div className="flex items-center space-x-6 pb-6 relative sm:flex-col sm:space-x-0 sm:space-y-4 sm:items-start">
        <BreadCrumbs className="sm:hidden" title="Qornex FRGX">
          <LevelsStatus />
        </BreadCrumbs>
      </div>
      {renderContent}
      <img className="absolute right-0 z-[-1] top-0 sm:hidden" src="/images/instrument/main/purpleShadow.png" />
      <img className="absolute left-[8%]  z-[-1] top-0 sm:hidden" src="/images/instrument/main/yellowShadow.png" />
    </BaseLayout>
  );
};
